<template>
  <v-form onsubmit="return false;" ref="metadataForm">
    <v-layout row wrap>
      <v-flex xs6 md4 class="px-2">
        <!-- Subtitle languages -->
        <v-autocomplete
          v-model="film.subtitle_languages"
          :items="DEFINES.COUNTRY_LANGUAGES"
          :label="$t('screener.film.subtitle_language.title')"
          item-text="name"
          item-value="code"
          multiple
          outline
          @input="resetAutocomplete"
          :search-input.sync="subtitleLangSearchInput"
          color="primary"
        ></v-autocomplete>
      </v-flex>
      <v-flex xs6 md4 class="px-2">
        <!-- Media languages -->
        <v-autocomplete
          v-model="film.film_languages"
          :items="DEFINES.COUNTRY_LANGUAGES"
          :label="$t('screener.film.media_language.title')"
          item-text="name"
          item-value="code"
          multiple
          @input="resetAutocomplete"
          :search-input.sync="filmLangSearchInput"
          color="primary"
          outline
        ></v-autocomplete>
      </v-flex>
      <v-flex xs6 md4 class="px-2">
        <!-- Released year -->
        <v-text-field
          v-model="film.released_year"
          :label="$t('screener.film.released_year.title')"
          type="number"
          outline
        ></v-text-field>
      </v-flex>
      <v-flex xs6 md4 class="px-2">
        <!-- Imbdb URL/ID -->
        <v-text-field
          v-model="film.imdb_ref"
          color="primary"
          :label="$t('screener.film.imdb_url')"
          type="text"
          outline
        ></v-text-field>
      </v-flex>
      <v-flex xs6 md4  class="px-2">
        <!-- Country -->
        <v-autocomplete
          v-model="film.countries"
          :items="countries"
          :label="$t('screener.film.country.title')"
          item-text="name"
          item-value="iso_3166_2"
          multiple
          @input="resetAutocomplete"
          :search-input.sync="countrySearchInput"
          color="primary"
          outline
        ></v-autocomplete>
      </v-flex>
      <!-- <v-flex class="px-2" xs6 md4>
        <v-text-field
          dense
          outline
          v-model="film.additional_metadata.en.productionDesigner.value"
          :label="$t(`screener.film.productionDesigner.title`)"
          color="primary"
        ></v-text-field>
      </v-flex> -->
      <v-flex xs6 md4 class="px-2">
        <!-- Sales Agent -->
        <v-text-field
          v-model="film.sales_agent.en"
          :label="$t('screener.film.sales_agent.title')"
          color="primary"
          outline
        ></v-text-field>
      </v-flex>
      <v-flex xs6 md4  class="px-2">
        <!-- Script Writer -->
        <v-text-field
          v-model="film.script_writer.en"
          :label="$t('screener.film.scripting.title')"
          color="primary"
          outline
        ></v-text-field>
      </v-flex>
      <v-flex xs6 md4 class="px-2">
        <!-- Cinematography -->
        <v-text-field
          v-model="film.cinematography.en"
          :label="$t('screener.film.cinematography.title')"
          color="primary"
          outline
        ></v-text-field>
      </v-flex>
      <v-flex xs6 md4  class="px-2">
        <!-- Film Editing -->
        <v-text-field
          v-model="film.editing.en"
          :label="$t('screener.film.editing.title')"
          color="primary"
          outline
        ></v-text-field>
      </v-flex>
      <v-flex xs6 md4  class="px-2">
        <!-- Music -->
        <v-text-field
          v-model="film.music.en"
          :label="$t('screener.film.music.title')"
          color="primary"
          outline
        ></v-text-field>
      </v-flex>
      <v-flex xs6 md4  class="px-2">
        <!-- Cast -->
        <v-text-field
          v-model="film.cast.en"
          :label="$t('screener.film.cast.title')"
          color="primary"
          outline
        ></v-text-field>
      </v-flex>
      <template v-for="field in additionalMetaDataFields">
        <template v-if="!['colorFormat','productionDesigner'].includes(field)">
          <v-flex :key="field" class="px-2" xs6 md4>
            <v-text-field
              dense
              outline
              v-model="film.additional_metadata.en[field].value"
              :label="$t(`screener.film.${field}.title`)"
              color="primary"
            ></v-text-field>
          </v-flex>
        </template>
      </template>
      <!-- Translation after these fields -->
      <v-flex xs12>
        <v-card elevation="2" tile class="mb-4">
          <v-card-title>
            <v-layout row wrap>
              <v-flex xs6>
                <v-tabs
                    background-color="transparent"
                    color="basil"
                    grow
                    v-model="widget_language"
                >
                  <v-tab
                    v-for="language in enabledLanguages" :key="language.value"
                  >
                      {{ language.text }}
                  </v-tab>
                </v-tabs>
              </v-flex>
              <v-flex xs6>
                <div style="float: right;" v-if="widget_language === 0">
                  <v-tooltip 
                        bottom
                        max-width="300"
                        color="grey darken-3"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            v-on="on"
                            color="grey lighten-3"
                            class="override-btn"
                            outlined
                            style="float:right"
                            small
                            @click="setFieldLanguageData(['genre','awards','colorFormat','productionDesigner'],film)"
                          >
                          {{ $t('language_copy_all_button_label') }}
                          </v-btn>
                        </template>
                        <div class="pa-2">
                          <div class="body-2">{{ $t('language_copy_all_button_info') }}</div>
                        </div>
                  </v-tooltip>
                </div>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-card-text class="mt-3">
            <v-tabs-items v-model="widget_language">
              <v-tab-item
                  v-for="language in enabledLanguages"
                  :key="language.name"
              >
                <v-layout row wrap>
                  <v-flex xs6 md4  class="px-2">
                    <!-- Genre -->
                    <v-text-field
                      v-model="film.genre[language.value]"
                      :label="$t('screener.film.genre.title')"
                      color="primary"
                      outline
                    ></v-text-field>
                  </v-flex>
                  <template v-for="field in additionalMetaDataFields">
                    <template v-if="['colorFormat','productionDesigner'].includes(field)">
                      <v-flex :key="field" class="px-2" xs6 md4>
                        <v-text-field
                          dense
                          outline
                          v-model="film.additional_metadata[language.value][field].value"
                          :label="$t(`screener.film.${field}.title`)"
                          color="primary"
                        ></v-text-field>
                      </v-flex>
                    </template>
                  </template>
                  <v-flex xs12 style="padding: 0px 14px 14px 14px;">
                    <!-- Description -->
                    <TextEditor
                      :title="$t('screener.film.awards.title',{lang_code:language.text})"
                      v-model="film.awards[language.value]"
                    />
                  </v-flex>
                </v-layout>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-form>
</template>

<script>
import rules from "@/validation";
import { mapState } from "vuex";
import TextEditor from "@/components/TextEditor";
import DEFINES from "@/defines";

export default {
  name: "MediaMetadataForm",
  props: {
    film: {
      type: Object,
      default: {},
    },
  },
  components: {
    TextEditor
  },
  data() {
    return {
      rules,
      subtitleLangSearchInput: null,
      filmLangSearchInput: null,
      countrySearchInput: null,
      widget_language:0,
      languages: DEFINES.LOCALES,
    };
  },
  computed: {
    ...mapState({
      countries: (state) => state.country.list,
      company: (state) => state.company.company,
    }),
    additionalMetaDataFields() {
      return Object.keys(this.film.additional_metadata[this.$i18n.locale])
    },
    enabledLanguages() {
      if (this.company) {
          return ('enabled_language_support' in this.company.custom_properties) ? this.company.custom_properties.enabled_language_support : this.i18n_locale; 
      }else{
          return this.i18n_locale
      }
    },
  },
  watch: {
    film: {
      deep: true,
      handler: function () {
        this.$emit("update:film", this.film);
      },
    },
  },
  mounted() {
    this.getCountries();
  },
  methods: {
    resetAutocomplete(){
      setTimeout(() => {
        this.countrySearchInput = null;
        this.subtitleLangSearchInput = null;
        this.filmLangSearchInput = null;
        this.filmTypesSearchInput = null
        }, 2000);
    },

    validate() {
      return this.$refs.metadataForm.validate();
    },
    async getCountries() {
      try {
        return await this.$store.dispatch("country/list");
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      }
    },
    setFieldLanguageData(fields, stateObject) {
      let __this = this
      fields.forEach(field => {
        __this.enabledLanguages.forEach((lang) => {
          if (lang.value !== 'en') {
            if (['colorFormat','productionDesigner'].includes(field)) {
              stateObject.additional_metadata[lang.value][field].value = stateObject.additional_metadata['en'][field].value 
            }else{
              stateObject[field][lang.value] = stateObject[field]['en']
            }
          }
        });
      });
    }
  },
};
</script>

<style>
</style>
